// lib/correlationId.ts
import { v4 as uuidv4 } from 'uuid';

let currentCorrelationId: string | null = null;

export const generateCorrelationId = (): string => {
  currentCorrelationId =
    typeof window !== 'undefined'
      ? window.crypto?.randomUUID() || uuidv4()
      : uuidv4();
  return currentCorrelationId;
};

export const getCurrentCorrelationId = (): string | null => {
  return currentCorrelationId;
};

export const setCorrelationId = (id: string): void => {
  currentCorrelationId = id;
};
